import axios from 'axios'
import router from '../router'
import { Toast, Indicator } from 'mint-ui'
// axios 配置
axios.defaults.timeout = 60000
axios.defaults.baseURL = '/api'
// 恢复袋鼠保 H5 登录令牌，供首页和“我的”页面刷新后继续使用。
if (localStorage.Authorization) {
  axios.defaults.headers.common.Authorization = localStorage.Authorization
}
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.url === '/auth/oauth/login' && !config.auth) {
    config.auth = {
      username: 'kangaroo-ins-h5',
      password: 'oshEty)ubPAK9yg~p&'
    }
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  const { data, config } = response
  if (config.url === '/auth/oauth/login' && data.errCode === 0) {
    axios.defaults.headers.common.Authorization = `Bearer ${data.data.value}`
    localStorage.Authorization = `Bearer ${data.data.value}`
    return response
  }
  if (data.errCode === 100002) {
    if (window.location.href.includes('electronicLetterApp')) {
      // 需要跳转 错误页
      router.replace({ name: 'noNetworkPage' })
      return response
    }
  }
  if (data.errCode && data.errCode !== 0 && config.extendConfig.showErrMag) {
    Toast({
      className: 'max-content-toast',
      message: data.msg
    })
  }
  return response
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})
export function updateToken () {
  axios.defaults.headers.common.Authorization = localStorage.Authorization
}
export function get (url, params, extendConfig = { showErrMag: true }) {
  return axios.get(url, { params, extendConfig }).catch((error) => {
    if (!navigator.onLine) {
      if (window.location.href.includes('electronicLetterApp')) {
        router.replace({ name: 'noNetworkPage' })
      }
    }
    console.log(error)
    alert(error)
    Indicator.close()
  })
}
export function post (url, data, config = {}, extendConfig = { showErrMag: true }) {
  return axios.post(url, data, {...config, extendConfig}).catch((error) => {
    if (!navigator.onLine) {
      if (window.location.href.includes('electronicLetterApp')) {
        router.replace({name: 'noNetworkPage'})
      }
    }
    console.log(error)
    alert(error)
    Indicator.close()
  })
}



// WEBPACK FOOTER //
// ./src/utils/http.js